module.exports = __webpack_public_path__ + "static/media/logo-min.3edd08c0.png";